export function defaultParams() {
  const m42 = {
    a: [2.1564270999383357, 0.8434669892882071, 0.7522785922246117, 0.5],
    b: [-0.0031533022160069855, -0.0038556900890443758, -0.010009120969340549, 0],
    mix: [1, 0, 0, 0, 1, 0, 0, 0, 1],
    beta: [10000.000000000007, 10000.000000000007, 10000.000000000007, 100],
    bias: [0, 0, 0.04682409587279897, 0],
    exposure: 1,
    gamma: 1,
    ground: 0,
    view: {
      a: 1.463284868397011,
      d: -0.09383673108726251,
      fovy: 0.01227455369231466,
      roll: 0,
    },
  }

  const m45 = {
    a: [5.114574480775759, 3.450128519829859, 3.5100669157322, 4.845075513435606],
    b: [-0.002497315896211854, -0.001969200980067999, -0.0052241833324896255, -0.0016067149842944476],
    mix: [1, 0, 0, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0.5],
    beta: [10000.000000000007, 10000.000000000007, 10000.000000000007, 10000.000000000007],
    bias: [-0.02008353199264593, 0, 0, 0],
    exposure: 1,
    gamma: 1,
    ground: 0,
    view: {
      a: 0.9905878324545823,
      d: 0.4207413467368718,
      fovy: 0.015285766772945008,
      roll: 0,
    },
  }

  const m31 = {
    a: [2.199295029536234, 2.0103885194367055, 1.9841269841269842, 2.022793120413001],
    b: [-0.001648548459980411, -0.0025677667840354867, -0.0033194448390797488, -0.01946514951398076],
    mix: [
      0.2, 0, 0,
      0, 1, 0,
      0, 0, 1,
      0.8, 0, 0],
    beta: [12.058291997314814, 43.60555950912844, 83.93141691026881, 65.15882757731914],
    bias: [0, 0, 0, 0],
    exposure: 1,
    gamma: 1,
    ground: 0,
    view: {
      a: 0.18668047898454176,
      d: 0.720410877137467,
      fovy: 0.013242880368563102,
      roll: -2.1982248398339577,
    },
  }

  const perseus = {
    a: [0.23, 0.23, 0.23, 1.],
    b: [-0.0015895982627862676, -0.0009480014211160102, -0.0021133462033806082, 0],
    mix: [1, 0, 0, 0, 1, 0, 0, 0, 1],
    beta: [50000.00000000002, 50000.00000000002, 50000.00000000002, 1],
    bias: [0, 0, 0, 0],
    exposure: 1,
    gamma: 1,
    ground: 0,
    view: {
      a: 0.8707219737107226,
      d: 0.7243653901912854,
      fovy: 0.0077661185967460656,
      roll: 0,
    },
  }

  const m101 = {
    a: [14.999999999999988, 1, 1, 1],
    b: [-0.060338206346271225, 0, 0, 0],
    mix: [1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    beta: [5132.13554142474, 1, 1, 1],
    bias: [-0.4992466526217914, 0, 0, 0],
    exposure: 1,
    gamma: 1,
    ground: 0,
    view: {
      a: 3.6791262758257988,
      d: 0.9486076070489848,
      fovy: 0.004814157234411436,
      roll: 0,
    },
  }

  return {
    m31, m42, m45, m101, perseus,
  }
}
